import AlarmIcon from "@mui/icons-material/Alarm";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import { Button, Tooltip } from "@mui/material";
import { useCallback } from "react";

import { queryClient } from "App";
import { useAuthentication } from "hooks/useAuthentication";
import { useStockNotification } from "hooks/useStockNotification";
import { useToast } from "hooks/useToast";
import { Product } from "types/models";

type Props = {
  product: Product;
};

const CONFIRMATION = "Te avisaremos por email cuando haya stock disponible";

export const ProductStockNotificationButton = ({ product }: Props) => {
  const { user } = useAuthentication();
  const { successToast } = useToast();
  const { hasNotification, isLoading, createNotification } =
    useStockNotification({
      productId: product.id,
      skip: !!(product.stock && product.stock > 0),
    });

  const handleCreateNotification = useCallback(async () => {
    try {
      await createNotification();
      queryClient.invalidateQueries(["stock_notifications"]);
      successToast(CONFIRMATION);
    } catch (error) {
      console.error(error);
    }
  }, [createNotification, successToast]);

  if (!user) return null;
  if (product.stock && product.stock > 0) return null;

  if (hasNotification) {
    return (
      <Tooltip title={CONFIRMATION}>
        <div>
          <Button variant="outlined" startIcon={<AlarmOnIcon />} disabled>
            Notificación activa
          </Button>
        </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Recibir email cuando haya stock disponible">
      <Button
        onClick={handleCreateNotification}
        disabled={isLoading}
        startIcon={<AlarmIcon />}
      >
        {isLoading ? "Creando..." : "Notificar stock"}
      </Button>
    </Tooltip>
  );
};
